import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, Field, GoogleButton } from "@/components/AuthShell";
import { fmtError } from "@/lib/api";
import { Loader2, Phone } from "lucide-react";

export default function SignUp() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ full_name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.password.length < 6) { setError("Password must be at least 6 characters."); return; }
    setBusy(true);
    try {
      await register(form);
      navigate("/onboarding", { replace: true });
    } catch (err) {
      setError(fmtError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Create your account" subtitle="Join your neighbours in staying ready together.">
      <form onSubmit={submit} className="ll-fade-up">
        <Field label="Full Name" testId="signup-name" required value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })} placeholder="Anita Sharma" />
        <Field label="Email" testId="signup-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="you@example.com" />
        <Field label="Password" testId="signup-password" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="At least 6 characters" />
        {error && <p data-testid="signup-error" className="text-[#DC2626] text-sm font-medium mb-4 bg-[#DC2626]/10 rounded-xl p-3">{error}</p>}
        <button type="submit" disabled={busy} data-testid="signup-submit" className="w-full bg-[#F97316] text-white rounded-2xl py-4 px-6 font-bold text-lg shadow-sm hover:-translate-y-0.5 hover:shadow-md transition-transform active:scale-95 min-h-[56px] flex items-center justify-center disabled:opacity-70">
          {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : "Create Account"}
        </button>
      </form>
      <div className="flex items-center gap-3 my-6"><div className="h-px flex-1 bg-[#111827]/10" /><span className="text-xs text-[#111827]/40 font-semibold uppercase">or</span><div className="h-px flex-1 bg-[#111827]/10" /></div>
      <GoogleButton label="Sign up with Google" />
      <Link to="/auth/sign-in" data-testid="signup-phone-cta" className="mt-3 w-full border-2 border-[#111827]/10 rounded-2xl py-3.5 font-bold flex items-center justify-center gap-2 text-[#111827] hover:border-[#F97316] transition-colors">
        <Phone className="w-4 h-4" /> Sign up with phone number
      </Link>
      <p className="text-center mt-8 text-[#111827]/70">Already have an account? <Link to="/auth/sign-in" data-testid="go-signin" className="font-bold text-[#F97316]">Sign in</Link></p>
    </AuthShell>
  );
}
